import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getAvailableCanadianProvinces} from 'src/openapi/admin/apis/GetAvailableCanadianProvincesApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectCanadianProvinces} from './services/dictionary-slice';

export const useCanadianProvinces = () => {
    const apiDispatch = useAppDispatch();
    const canadianProvinces = useSelector(selectCanadianProvinces);

    const loadCanadianProvinces = useCallback(() => {
        if (!canadianProvinces.length) {
            apiDispatch(getAvailableCanadianProvinces());
        }
    }, [canadianProvinces.length, apiDispatch]);

    const getProvinceByCode = useCallback((code: string) => {
        return canadianProvinces.find(e => e.code === code);
    }, [canadianProvinces]);

    return {canadianProvinces, loadCanadianProvinces, getProvinceByCode};
};
